import { Navigate } from "react-router-dom";

export default function MasterBindPage() {
  return <Navigate to="/forex/master-accounts/bind" replace />;
}
